import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface Props {
  label: string
  value: ReactNode
  icon?: ReactNode
  accent?: 'brand' | 'emerald' | 'violet' | 'amber' | 'rose' | 'green'
  hint?: ReactNode
  /** Quando definido, o card vira clicável (hover + cursor). */
  onClick?: () => void
}

const MAP: Record<NonNullable<Props['accent']>, string> = {
  brand:   'bg-brand-50    text-brand-700    ring-brand-100',
  emerald: 'bg-emerald-50  text-emerald-700  ring-emerald-100',
  violet:  'bg-violet-50   text-violet-700   ring-violet-100',
  amber:   'bg-amber-50    text-amber-700    ring-amber-100',
  rose:    'bg-rose-50     text-rose-700     ring-rose-100',
  green:   'bg-green-50    text-green-700    ring-green-100',
}

export function KpiCard({ label, value, icon, accent = 'brand', hint, onClick }: Props) {
  const clickable = typeof onClick === 'function'
  return (
    <div
      onClick={onClick}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick!() } } : undefined}
      className={cn(
        'bg-white rounded-md ring-1 ring-gray-200 p-5 flex items-start justify-between gap-4',
        clickable && 'cursor-pointer transition hover:ring-brand-300 hover:bg-gray-50/60',
      )}
    >
      <div>
        <div className="text-[11px] uppercase tracking-wider text-gray-500">{label}</div>
        <div className="text-2xl font-semibold text-gray-800 mt-1">{value}</div>
        {hint && <div className="text-[11px] text-gray-500 mt-1">{hint}</div>}
      </div>
      {icon && (
        <div className={cn('w-11 h-11 rounded-md flex items-center justify-center ring-1', MAP[accent])}>
          {icon}
        </div>
      )}
    </div>
  )
}
